import React, { Component } from 'react';
import { Form, Icon, Input, Button, Row, Col } from 'antd';
//import NewsletterForm from './newsletterForm';
const FormItem = Form.Item;
class Footer extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);
      }
    });
  }
  render() {
    return (
      <div className="footer">
       <div className="content-wrap">
          <Row gutter={40} >
            <Col span={24}>
              <hr/>
            </Col>
            <Col sm={6} xs={6} className="socials mobile-hidden">
              <a target="blank_" href="https://www.facebook.com/pangramia/"><Icon type="facebook" /></a>
            </Col>
            <Col sm={12} xs={20} className="mobile-hidden">
               15/f Radio city, 505 Hennessy road, Causeway bay, HONG KONG
            </Col>
            <Col sm={6} xs={20} className="copyright mobile-align-center">
              © Pangramia,   2023
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Landing/footer.js